import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fb58ade"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "option" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "option" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "option" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "option" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "option" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "tipBar" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "option" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "footer_area" }
const _hoisted_16 = { key: 1 }

import provide_key from "@/constant/provide_key";
import { inject, nextTick, ref } from "vue";
import axios from "axios";
import emailConstant from "@/constant/email_constant";
import zhCountry from "@/utils/languages/zh/json/country.json";
import enCountry from "@/utils/languages/en/json/country.json";
import { useI18n } from "vue-i18n";
import { showToast } from "vant";

export default /*#__PURE__*/_defineComponent({
  __name: 'FormBar',
  setup(__props) {

const { t, locale } = useI18n();

const shrink: boolean | undefined = inject(provide_key.SHRINK);
const visible = ref<boolean>(false);
let timer: any;
const nameInput = ref<string>("");
const companyInput = ref<string>("");
const phoneInput = ref<string>("");
const emailInput = ref<string>("");
const addressInput = ref<string>("");
const messageInput = ref<string>("");
const matchWords = ref<string[]>([]);

const verifyEmpty = () => {
  const forms = [
    nameInput.value,
    companyInput.value,
    phoneInput.value,
    emailInput.value,
    addressInput.value,
    messageInput.value,
  ]
  const pass = forms.every(form => form.trim() !== "")
  if(!pass) showToast(t("company.EMPTY_TOAST"))
  return pass
};

const onSelect = (tip: string) => {
  addressInput.value = tip;
};

const onFocus = () => {
    const countrys =
      locale.value === "zh"
        ? Object.values(zhCountry)
        : Object.values(enCountry);
    matchWords.value = countrys
    visible.value = true
}

const onChang = () => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    if (addressInput.value === "") return;
    const countrys =
      locale.value === "zh"
        ? Object.values(zhCountry)
        : Object.values(enCountry);
    matchWords.value = matchWord(addressInput.value, countrys);
    visible.value = true;
  }, 500);
};

const onBlur = () => {
    setTimeout(() => {
        visible.value = false
    }, 100)
}

const requestToSendEmail = (data: any) => {
  loading.value = true;
  axios({
    method: "post",
    url: "https://api.emailjs.com/api/v1.0/email/send",
    data,
  })
    .then((res) => {
      showToast(t("company.SUCCESS_TOAST"));
      loading.value = false;
    })
    .catch((res) => {
      showToast(t("company.ERROR_TOAST"));
      loading.value = false;
    });
};

const onSend = () => {
  if (loading.value || !verifyEmpty()) return;
  const option = {
    service_id: emailConstant.SERVICE_ID,
    template_id: emailConstant.TEMPLATE_ID,
    user_id: emailConstant.PUBLIC_KEY,
    template_params: {
      name: nameInput.value,
      company: companyInput.value,
      phone: phoneInput.value,
      email: emailInput.value,
      address: addressInput.value,
      message: messageInput.value,
    },
  };
  requestToSendEmail(option);
};

const loading = ref<boolean>(false);

const matchWord = (input: string, words: string[]) => {
  const regex = new RegExp(input, "i"); // 'i' flag for case-insensitive matching
  return words.filter((word) => regex.test(word));
};

return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", {
    id: "form_bar",
    style: _normalizeStyle({
      'border-left': _unref(shrink) ? '' : '1px solid #3e3e3e',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("company.FORM_NAME")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameInput).value = $event))
      }, null, 512), [
        [_vModelText, nameInput.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("company.FORM_COMPANY")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((companyInput).value = $event))
      }, null, 512), [
        [_vModelText, companyInput.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("company.FORM_PHONE")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneInput).value = $event))
      }, null, 512), [
        [_vModelText, phoneInput.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("company.FORM_EMAIL")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailInput).value = $event))
      }, null, 512), [
        [_vModelText, emailInput.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("company.FORM_ADDRESS")), 1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addressInput).value = $event)),
        onBlur: onBlur,
        onInputCapture: onChang,
        onFocus: onFocus
      }, null, 544), [
        [_vModelText, addressInput.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matchWords.value, (tip, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "bar",
            key: index,
            onClick: ($event: any) => (onSelect(tip))
          }, _toDisplayString(tip), 9, _hoisted_12))
        }), 128))
      ], 512), [
        [_vShow, visible.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("company.FORM_MESSAGE")), 1),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((messageInput).value = $event))
      }, null, 512), [
        [_vModelText, messageInput.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", {
        class: "button",
        onClick: onSend
      }, [
        (loading.value)
          ? (_openBlock(), _createBlock(_component_van_loading, {
              key: 0,
              size: "20",
              color: "#fff"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("company.BUTTON")), 1))
      ])
    ])
  ], 4))
}
}

})